export default "__VITE_ASSET__bc7063af__"